export default function ProductSkeleton({ count = 8 }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-2xl border border-neutral-200 bg-white overflow-hidden animate-pulse">
          <div className="aspect-square bg-neutral-100" />
          <div className="p-3 space-y-2">
            <div className="h-3 w-1/3 bg-neutral-100 rounded" />
            <div className="h-4 w-4/5 bg-neutral-100 rounded" />
            <div className="h-4 w-1/2 bg-neutral-100 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}
